import ApiClient from "../api-client.js";

export const SERVICE_NAME = "business-hours";
const adminClient = new ApiClient({ servicePath: `admin/${SERVICE_NAME}` });

export const getBusinessHour = async ({ id }) => {
  return await adminClient.get({
    path: `/${id}`,
  });
};

export const createBusinessHour = async ({ body }) => {
  return await adminClient.post({
    body,
  });
};

export const editBusinessHour = async ({
  id,
  body,
  successMessage = "Business hour edited successfully!",
}) => {
  return await adminClient.patch({
    path: `/${id}`,
    body,
    successMessage,
  });
};

export const deleteBusinessHour = async ({ id }) => {
  return await adminClient.delete({
    path: `/${id}`,
  });
};
